import { Checkbox } from "@material-ui/core";
import { FC } from "react";
import { useStyles } from "../styles";
import { DriverData } from "types/DaAndFleet";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { useDispatch } from "react-redux";
import { addOrRemoveIdFromUpdateList } from "actions/daAndFleetActions";

interface DaCheckboxProps {
  data: DriverData;
  disabled?: boolean;
}

export const DaCheckbox: FC<DaCheckboxProps> = ({ data, disabled }) => {
  const classes = useStyles();
  const {
    driverData: { idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);
  const dispatch = useDispatch();

  return (
    <Checkbox
      onChange={() => dispatch(addOrRemoveIdFromUpdateList("da", data?.id))}
      checked={idListForUpdate?.includes(data.id)}
      className={classes.selectCheckbox}
      disabled={disabled}
    />
  );
};
